import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import copy from 'copy-to-clipboard';
import { getCurrencyCode } from 'utils/helpers';
import Table from 'components/Credit24/Core/Table';

const propTypes = {
  referenceNumber: PropTypes.string,
  toPay: PropTypes.number,
  customerBank: PropTypes.string,
};

const getReceiverBanksForCustomerBank = (customerBank) => {
  const bank = customerBank && customerBank.toLowerCase();
  switch (bank) {
    case 'op':
    case 'danske':
    case 'nordea':
      return [bank];
    case 'sampo':
      return ['danske'];
    default:
      return ['nordea', 'op', 'danske'];
  }
};

class PaymentDetails extends Component {
  onCopy(value) {
    try {
      copy(value);
    } catch (e) {
      if (DEBUG) {
        console.log(e);
      }
    }
  }

  render() {
    const { referenceNumber, toPay, customerBank } = this.props;
    const { formatMessage, formatNumber } = this.context.intl;

    const copyButton = (value) => (
      <button
        type="button"
        className="link"
        onClick={() => this.onCopy(value)}
      >
        <FormattedMessage id="selfservice.invoices.paymentDetails.copy" />
      </button>
    );

    const items = [
      {
        id: 'provider',
        label: formatMessage({ id: 'selfservice.invoices.paymentDetails.provider' }),
        value: formatMessage({ id: 'selfservice.invoices.paymentDetails.provider.value' }),
        button: copyButton(formatMessage({ id: 'selfservice.invoices.paymentDetails.provider.value' })),
      },
    ];

    getReceiverBanksForCustomerBank(customerBank).forEach((bankId) => {
      items.push({
        id: `iban-${bankId}`,
        label: formatMessage({ id: 'selfservice.invoices.paymentDetails.iban' }),
        value: (
          <span>
            {formatMessage({ id: `selfservice.invoices.paymentDetails.iban.number.${bankId}` })}
            &nbsp;
            {MOBILE_WALLET
              && <FormattedMessage id={`mw.paymentDetails.iban.bank.${bankId}`} />}
            {!MOBILE_WALLET
              && (
              <span className="txt-muted">
                {formatMessage({ id: `selfservice.invoices.paymentDetails.iban.bank.${bankId}` })}
              </span>
              )}
          </span>
        ),
        button: copyButton(formatMessage({ id: `selfservice.invoices.paymentDetails.iban.number.${bankId}` })),
      });
    });

    items.push(
      {
        id: 'refNumber',
        label: formatMessage({ id: 'selfservice.invoices.paymentDetails.referenceNumber' }),
        value: referenceNumber,
        button: copyButton(referenceNumber),
      },
      {
        id: 'totalSum',
        label: formatMessage({ id: 'selfservice.invoices.paymentDetails.totalSum' }),
        value: formatNumber(
          toPay / 100,
          {
            style: 'currency', currency: getCurrencyCode(), useGrouping: true, maximumFractionDigits: 2,
          }
        ),
        button: copyButton(formatNumber(
          toPay / 100,
          {
            style: 'currency', currency: getCurrencyCode(), useGrouping: true, maximumFractionDigits: 2,
          }
        )),
      }
    );

    return (
      <Table
        rows={items}
        cells={['label', 'value', 'button']}
        cssClass="table--payment-details"
      />
    );
  }
}

PaymentDetails.contextTypes = {
  intl: PropTypes.object,
};

PaymentDetails.propTypes = propTypes;

export default PaymentDetails;
